/**
 * UPDATE_MEMBER_PROFILE_FAILURE
 */
function* updateMemberProfileFailure({ error }) {
  console.log('UPDATE_PROFILE_INFO_FAILURE')
}

export default updateMemberProfileFailure
